<template>
<div style="margin: 10px" class="container-fluid">
    <div class="row">
        <!-----------------------------------------------------------------------------------------------MODAL EDIT-------------------------->
        <b-modal ref="document-modal" hide-footer hide-header title="Edit Document">
            <div style="padding: 0 10px">
                <div style="margin: 10px 0">
                    <h4 class="service_txt">Edit Document</h4>
                </div>
                <form style="padding: 20px 0" data-parsley-validate novalidate @submit.prevent>
                    <div>
                        <label class="label_add" for="userName">Document Name</label>
                        <input type="text" n parsley-trigger="change" required placeholder="Enter service name" class="input_add" v-model="selectedRows.documentName">
                    </div>
                    <div style="margin-top: 20px">
                        <label class="label_add" for="userName">Document Description</label>
                        <textarea type="text" parsley-trigger="change" required placeholder="Enter service description" class="input_add2" v-model="selectedRows.documentDescription"></textarea>
                    </div>
                    <div style="margin-top: 20px; text-align: right">
                        <button class="btn_add" type="submit" @click="editDocuments(selectedRows.documentId)">
                            Edit Document
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>
        <!-----------------------------------------------------------------------------------------------MODAL EDIT ends-------------------------->
        <!-----------------------------------------------------------------------------------------------MODAL EDIT-------------------------->
        <b-modal ref="document-modal-delete" hide-footer hide-header title="Edit Document">
            <div style="padding: 0 10px">
                <div style="margin: 10px 0">
                    <h4 class="service_txt">Delete Document</h4>
                </div>
                <form style="padding: 20px 0" data-parsley-validate novalidate @submit.prevent>
                    <div>
                        <label class="label_add" for="userName">Document Name</label>
                        <input type="text" n parsley-trigger="change" required placeholder="Enter service name" class="input_add" v-model="selectedRows.documentName">
                    </div>
                    <div style="margin-top: 20px">
                        <label class="label_add" for="userName">Document Description</label>
                        <textarea type="text" parsley-trigger="change" required placeholder="Enter service description" class="input_add2" v-model="selectedRows.documentDescription"></textarea>
                    </div>
                    <div style="margin-top: 20px; text-align: right">
                        <button class="btn_add" type="submit" @click="deleteDocument(selectedRows.documentId)">
                            Delete Document
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>
        <!-----------------------------------------------------------------------------------------------MODAL EDIT ends-------------------------->
        <!-----------------------------------------------------------------------------------------------Document CREATE-------------------------->
        <h4 class="service_txt mt-0 mb-3">Documents</h4>
        <div class="container">
            <div class="row">
                <div style="margin-top: 20px;" class="col-lg-5">
                    <div class="document_div">
                        <h4 class="txt_add mb-3">Add Document</h4>
                        <div class="">
                            <form data-parsley-validate novalidate @submit.prevent>
                                <div class="">
                                    <label class="label_add" for="userName">Document Name</label>
                                    <input type="text" n parsley-trigger="change" required placeholder="Enter service name" class="input_add" v-model="newdocumentName">
                                </div>
                                <div style="margin-top: 20px" class="">
                                    <label class="label_add" for="userName">Document Description</label>
                                    <textarea type="text" parsley-trigger="change" required placeholder="Enter service description" class="input_add2" v-model="newdocumentDescription"></textarea>
                                </div>
                                <div style="margin-top: 20px; text-align: right">
                                    <button class="btn_add" type="submit" @click="addDocuments()">
                                        Add Document
                                    </button>
                                </div>
                            </form>
                        </div>
                        <!-- end col -->
                    </div>
                </div>
                <!-----------------------------------------------------------------------------------------------Document CREATE ENDS-------------------------->
                <div style="margin-top: 20px;" class="col-lg-7">
                    <div v-if="rows.length" class="table_add">
                        <h4 style="margin-left: 40px" class="txt_add mb-3">List of Documents</h4>
                        <vue-bootstrap4-table style="padding: 20px" :rows="rows" :columns="columns" :config="config">
                            <template slot="empty-results">
                                No Document found
                            </template>
                            <template slot="id" slot-scope="props">
                                <span>
                                    {{props.row.vbt_id}}
                                </span>
                            </template>
                            <template slot="documentName" slot-scope="props">
                                <span>
                                    {{props.cell_value}}
                                </span>
                            </template>
                            <template slot="documentId" slot-scope="props">
                                <span>
                                    {{props.cell_value}}
                                </span>
                            </template>
                            <template slot="action" slot-scope="props">
                                <!-- <span class="">
                                    <a @click="editDocument(props.row)" class="btn_edit" style="">Setting</a>
                                </span> -->
                                <b-button class="btn_edit" @click="editDocument(props.row)" id="show-btn">Setting</b-button>
                                <b-button class="btn_edit2" @click="DeleteDocumentModal(props.row)" id="show-btn">Delete</b-button>
                            </template>
                            <template slot="sort-asc-icon">
                                <i class="fas fa-sort-up"></i>
                            </template>
                            <template slot="sort-desc-icon">
                                <i class="fas fa-sort-down"></i>
                            </template>
                            <template slot="no-sort-icon">
                                <i class="fas fa-sort"></i>
                            </template>
                        </vue-bootstrap4-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src

///////// IMPORT COOKIE SERVICE
import cookieOps from "@/services/cookieOps.js";
/////////////////////////
import router from '@/router/index'
///////// IMPORT COOKIE SERVICE

import VueBootstrap4Table from 'vue-bootstrap4-table'

import httpRequest from "@/services/httpRequests.js";
export default {
    name: 'documents',
    components: {
        VueBootstrap4Table
    },
    data() {
        return {
            newdocumentName: '',
            newdocumentDescription: '',
            selectedRows: [],
            columns: [{
                    label: "S/N",
                    name: "id",
                    slot_name: "id",
                    column_classes: "my my-column-class2"
                },
                {
                    label: "Document Name",
                    name: "documentName",
                    //   slot_name: "stateName",
                    sort: false,
                },
                {
                    label: "Document Id",
                    name: "documentId",
                    sort: false,
                },
                {
                    label: "Action",
                    name: "id",
                    slot_name: "action",
                }

            ],
            newbuild: [],
            rows: [],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: false,
                selected_rows_info: false,
                highlight_row_hover: true,
                card_title: "List of Documents",
                global_search: {
                    placeholder: "Search Documents",
                    visibility: false,
                    case_sensitive: false,
                },
                pagination: true, // default true
                pagination_info: false, // default true
                num_of_visibile_pagination_buttons: 7, // default 5
                per_page: 5, // default 10
                per_page_options: [5, 10, 20, 30],
            },

        };
    },

    beforeRouteEnter(to, from, next) {
        const fetch = httpRequest.get('document/get/all').then(function (res) {
            next(vm => vm.setData(res))
            console.log(res)
        })
    },

    mounted() {

    },

    /// SCOPE METHODS
    methods: {
        editDocument(cell_value) {
            // console.log(cell_value);
            this.$refs['document-modal'].show()
            this.selectedRows = cell_value
        },
        DeleteDocumentModal(cell_value) {
            // console.log(cell_value);
            this.$refs['document-modal-delete'].show()
            this.selectedRows = cell_value
        },
        //////// sweet allert serivice
        alertDisplay(w, x, y) {
            // $swal function calls SweetAlert into the application with the specified configuration.
            this.$swal(w, x, y);
        },

        setData(data) {
            //let allDocuments = httpRequest.detokenizeData(data.data.dataToken)
            // console.log(data);
            this.rows = data.data.documents
        },
        addDocuments() {
            let thiss = this
            const createDocument = httpRequest.post('document/create', {
                'documentName': this.newdocumentName,
                'documentDescription': this.newdocumentDescription
            }).then(function (res) {
                if (res.data.code == 's200') {
                    thiss.newbuild.documentName = thiss.newdocumentName;
                    thiss.newbuild.documentId = '20000';
                    thiss.newbuild.deletedStatus = '0';
                    thiss.newbuild.slug = thiss.newdocumentName;
                    thiss.newbuild.suspendStatus = '0';
                    thiss.rows.push(thiss.newbuild)
                    // console.log(thiss.rows);
                    thiss.alertDisplay('Document Created', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('Document Not Created', res.data.message, 'error');
                }
            })
        },
        // DELETE DOCUMENT
        deleteDocument() {
            let thiss = this
            const documentId = this.selectedRows.documentId;
            const deleteService = httpRequest.put(`document/delete/${documentId}`, {}).then(function (res) {
                console.log('RESPONSE', res)
                if (res.data.code == 's200') {
                    thiss.alertDisplay('Service Deleted', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('Service Not Deleted', res.data.message, 'error');
                }
            })
            this.$refs['document-modal-delete'].hide();
        },
        // Edit Document
        editDocuments() {
            // let thiss = this
            const documentId = this.selectedRows.documentId
            const editDocument = httpRequest.put(`document/edit/${documentId}`, {
                'documentName': this.selectedRows.documentName,
                'documentDescription': this.selectedRows.documentDescription
            }).then(function (res) {
                if (res.data.code == 's200') {
                    this.newbuild.documentName = this.selectedRows.documentName;
                    this.newbuild.documentDescription = this.selectedRows.documentDescription
                    this.newbuild.documentId = '20000';
                    this.newbuild.deletedStatus = '0';
                    this.newbuild.slug = this.newdocumentName;
                    this.newbuild.suspendStatus = '0';
                    this.rows.push(this.newbuild)
                    // console.log(thiss.rows);
                    thiss.alertDisplay('Document Created', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('Document Not Created', res.data.message, 'error');
                }
            })
            this.$refs['document-modal'].hide()
        },
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

.service_txt {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
}

.my {
    background-color: #555A6E;
}

a {
    text-decoration: none;
}

.column1 {
    background-color: #494949;
}

.column2 {
    background-color: #494949;
}

.btn_edit {
    width: auto;
    height: auto;
    padding: 10px;
    background: #E9F0FF;
    margin: 5px 0;
    border: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #1A87CA;
}

.btn_edit2 {
    width: auto;
    height: auto;
    padding: 10px;
    background: #ab3b48;
    margin: 5px 5px;
    border: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #E9F0FF;
}

.btn_edit:hover {
    width: auto;
    height: auto;
    padding: 10px;
    background: #E9F0FF;
    margin: 5px 0;
    cursor: pointer;
    border: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #1A87CA;
}

.btn_add {
    /* padding: 20px; */
    border: none;
    width: 150px;
    height: 50px;
    background: #555A6E;
    border-radius: 4px;

    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #FFFFFF;

}

.txt_add {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
}

template {
    position: relative;
    min-height: 100%;
}

.card-header {
    font-weight: 600 !important;
    background-color: red;
}

body {
    padding-bottom: 60px;
    overflow-x: hidden;
}

.authentication-bg.enlarged {
    min-height: 100px;
}

.document_div {
    width: 100%;
    height: 407px;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px 40px;
}

.document_div2 {
    width: 100%;
    height: auto;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px 10px;
}

body.authentication-bg {
    background-image: url(../../assets/bg-light-img.jpg);
    background-size: cover;
    background-position: center;
}

.input_add {
    padding: 20px;
    width: 100%;
    height: 55px;

    background: #FFFFFF;
    border: 0.5px solid #D3D8DD;
    box-sizing: border-box;
    border-radius: 4px;
}

.table_add {
    width: 100%;
    height: auto;
    padding: 20px 0;
    background: #FFFFFF;
    border-radius: 4px;
}

.input_add2 {
    padding: 20px;
    width: 100%;
    height: 87px;
    background: #FFFFFF;
    border: 0.5px solid #D3D8DD;
    box-sizing: border-box;
    border-radius: 4px;
}

.label_add {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 115.5%;
    display: flex;
    align-items: center;
    color: #494949;
    margin-bottom: 10px;
}
</style>
